export const APP_NAME = 'kiosko';
